import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from 'react-hook-form';
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import findOpcaoConsultaLote from "../../service/findOpcaoConsultaLote";
import { SortOrder } from "primereact/api";
import { FileUpload, FileUploadHandlerEvent, FileUploadHeaderTemplateOptions, FileUploadSelectEvent, FileUploadUploadEvent, ItemTemplateOptions } from "primereact/fileupload";
import { Tag } from "primereact/tag";
import { ProgressBar } from "primereact/progressbar";
import { PickList } from "primereact/picklist";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";


export default function ConsultaLoteCadastrar({ consultaLote, onClose, onSave, msgs }: { consultaLote: any, onClose: () => void, onSave: (consultaLote: any) => void, msgs: any }) {
    const { t } = useTranslation();
    const [opcoes, setOpcoes] = useState<any | null>(null);
    const [totalSize, setTotalSize] = useState(0);
    const [files, setFiles] = useState<any>([]);
    const fileUploadRef = useRef<FileUpload>(null);
    const hiddenFileInputRef = useRef<HTMLInputElement>(null);
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState<any[]>([]);
    const [campos, setCampos] = useState<any[]>([]);
    const defaultValues = {
        opcaoConsultaLote: null
    };

    const onChangePickList = (event: any) => {
        setSource(event.source);
        setTarget(event.target);
        if (event.target && event.target.length > 0) {
            const lista: any[] = [];
            event.target.map((f: any) => {
                lista.push(f.id)
            });
            setCampos(lista)
        }
    };

    const pickItemTemplate = (item: any) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                <div className="flex-1 flex flex-column gap-2">
                    <span className="font-bold">{item.nome}</span>
                </div>
            </div>
        );
    };


    const {
        control,
        formState: { errors },
        handleSubmit
    } = useForm({ defaultValues });

    const [camposError, setCamposError] = useState<string | null>(null);

    const onSubmit = (data: any) => {
        if (target.length === 0) {
            setCamposError('Selecione pelo menos um campo.');
            return;
        }
        setCamposError(null);
        if (!data.opcaoConsultaLote) return;
        if (files.length === 0) {
            msgs.current?.clear();
            msgs.current?.show([{ sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Carregue um arquivo antes de salvar.', closable: false }]);
            return;
        }

        const rowCount = files[0]?.rows ?? 0;
        const opcaoNome = data.opcaoConsultaLote.nome;

        confirmDialog({
            header: 'Atenção',
            message: `Você solicitou o processamento de ${rowCount} consulta(s) na opção "${opcaoNome}". Esta ação não poderá ser revertida após a confirmação. Continuar?`,
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            icon: 'pi pi-exclamation-triangle',
            accept: () => save(data),
        });
    };


    const save = (data: any) => {
        const consultaLote = {
            id: undefined,
            opcaoConsultaLote: data.opcaoConsultaLote.id,
            campos: campos,
            arquivoEntrada: files[0]?.data
        }
        window.scrollTo(0, 0);
        onSave(consultaLote);
    }

    const getFormErrorMessage = (name: string) => {
        type ObjectKey = keyof typeof errors;
        const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
        return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onTemplateSelect = (e: FileUploadSelectEvent) => {
        let _totalSize = totalSize;
        let files = e.files;

        for (let i = 0; i < files.length; i++) {
            _totalSize += files[i].size || 0;
        }

        setTotalSize(_totalSize);
    };

    const uploadHandler = async (e: FileUploadHandlerEvent) => {
        if (e.files.length + files.length > 1) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Limite de arquivos atingido', closable: false }

            ]);
        }
        else {
            e.files.forEach(async (file: any) => {
                const reader = new FileReader();
                let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

                reader.readAsDataURL(blob);

                reader.onloadend = function () {
                    const base64data = reader.result as string;
                    const text = atob(base64data.split(',')[1]);
                    const rowCount = text.split('\n').filter(l => l.trim().length > 0).length - 1;
                    setFiles((files: any) => [...files, { name: file.name, data: base64data, rows: Math.max(0, rowCount) }])
                };
            });
            if (fileUploadRef && fileUploadRef.current) {
                fileUploadRef.current.clear()
            }
        }

    }

    const onTemplateUpload = (e: FileUploadUploadEvent) => {
        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
    };

    const onTemplateRemove = (file: File, callback: Function) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };

    const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
        const { className, uploadButton, cancelButton } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                <Button
                    type="button"
                    icon="pi pi-fw pi-file"
                    className="custom-choose-btn p-button-rounded p-button-outlined"
                    onClick={() => hiddenFileInputRef.current?.click()}
                />
                {uploadButton}
                {cancelButton}
                <div className="flex-score align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 10 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (inFile: object, props: ItemTemplateOptions) => {
        const file = inFile as any;
        return (
            <div className="flex-score align-items-center flex-wrap">
                <div className="flex-score align-items-center" style={{ width: '40%' }}>
                    <i style={{ fontSize: '2.5rem' }} className="pi pi-file-excel"></i>
                    <span className="flex-score flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex-score align-items-center flex-column">
                <i className="pi pi-file mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    arrate e solte seu arquivo aqui
                </span>
            </div>
        );
    };

    const fileTemplate = (file: any) => {
        return (
            <div className="flex align-items-center gap-3 border-1 surface-border border-round p-3 m-2">
                <i className="pi pi-file-excel" style={{ fontSize: '1.8rem', color: '#217346' }}></i>
                <span className="flex-1 font-medium">{file.name}</span>
                <Button type="button" icon="pi pi-trash" rounded outlined severity="danger"
                    onClick={() => setFiles(files.filter((f: any) => f !== file))} />
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-file', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    useEffect(() => {
        const lazyState = {
            first: 0,
            rows: 100,
            page: 1,
            sortField: 'nome',
            sortOrder: SortOrder.DESC
        };
        findOpcaoConsultaLote(lazyState).then((data) => setOpcoes(data.opcoes))
    }, [])



    return (
        <>
            <ConfirmDialog />
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
                <div>
                    <div className="grid">

                        <div className="col">
                            <Controller
                                name="opcaoConsultaLote"
                                control={control}
                                rules={{ required: 'Opção é Obrigatório' }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.opcaoConsultaLote })}></label>
                                        <span className="">
                                            <div>
                                                <label htmlFor="opcaoConsultaLote" className="font-bold block mb-2 required">{t('opcaoConsulta')} </label>
                                                <Dropdown style={{ width: '50%' }} value={field.value} onChange={(e) => { field.onChange(e.value); setSource(e.value.exportacoes) }} options={opcoes} optionLabel="nome" placeholder="Selecione Opção"
                                                    filter className="w-full md:w-14rem" />
                                            </div>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />

                        </div>
                        <div className="col p-fluid flex flex-wrap">






                        </div>
                    </div>
                    <div className="grid">
                        <div style={{ minWidth: '800px' }}>
                            <input
                                ref={hiddenFileInputRef}
                                type="file"
                                accept=".csv"
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (!file) return;
                                    if (files.length >= 1) {
                                        msgs.current?.clear();
                                        msgs.current?.show([{ sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Limite de arquivos atingido', closable: false }]);
                                        e.target.value = '';
                                        return;
                                    }
                                    const reader = new FileReader();
                                    reader.readAsDataURL(file);
                                    reader.onloadend = () => {
                                        const base64data = reader.result as string;
                                        const text = atob(base64data.split(',')[1]);
                                        const rowCount = text.split('\n').filter(l => l.trim().length > 0).length - 1;
                                        setFiles((prev: any) => [...prev, { name: file.name, data: base64data, rows: Math.max(0, rowCount) }]);
                                    };
                                    e.target.value = '';
                                }}
                            />
                            <FileUpload ref={fileUploadRef} name="demo[]" customUpload auto uploadHandler={uploadHandler} multiple accept=".csv" maxFileSize={10000000}
                                onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                                headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                                chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                            {files.length > 0 && (
                                <div className="mt-2">
                                    {files.map((file: any) => fileTemplate(file))}
                                </div>
                            )}
                        </div>
                    </div>
                    <br></br>
                    <br></br>
                    <div className="grid">
                        <PickList dataKey="id" onChange={(e) => { onChangePickList(e) }} itemTemplate={pickItemTemplate} showSourceControls={false} showTargetControls={true} source={source} target={target} filter filterBy="nome"
                            sourceHeader="Campos" targetHeader="Selecionados" sourceStyle={{ height: '14rem' }} targetStyle={{ height: '14rem' }}
                            sourceFilterPlaceholder="Busca" targetFilterPlaceholder="Busca" />
                        {camposError && <small className="p-error">{camposError}</small>}
                    </div>

                </div>
                <br></br>
                <br></br>
                <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "1rem" }} className=" flex">
                    <Button style={{ marginRight: "1rem", backgroundColor: '#183462' }} label="Salvar" type="submit" />
                    <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
                </div>
            </form>
        </>
    )
}

